export default function () {
  const gatsbyCountryCodeSplitted = process.env.GATSBY_COUNTRY_CODE.split('-');
  let defaultCountryCode = '';

  if (gatsbyCountryCodeSplitted.length === 2) defaultCountryCode = gatsbyCountryCodeSplitted[1];
  else defaultCountryCode = gatsbyCountryCodeSplitted[0];

  return defaultCountryCode.toLowerCase();
}
